import React, { useContext, useEffect } from "react";
import { useState } from "react";
import articlePic from "../../assets/images/article.png";
// import InsertProductModal from "../../Components/admin-panel/product-management/insert-product";
import InsertProductModal from "components/admin-panel/product-management/insert-product";
import AddEditArticleModal from "pages/Blog/AddEditArticleModal";
import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";

const ManagementContext = React.createContext({
  updater: {},
  setUpdater: () => {},
  controllerProduct: {},
  setControllerProduct: {},
  showModalArticle: "",
  setShowModalArticle: () => {},
});

export default ManagementContext;

export const ManagementContextProvider = ({ children }) => {
  const auth = useContext(AuthenticationContext);

  const [controllerProduct, setControllerProduct] = useState({
    show: false,
    type: "add",
    details: {},
  }); // کنترلر برای مدیریت نمایش مدال افزودن و ویرایش محصول
  const [showModalArticle, setShowModalArticle] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState("");
  const [type, setType] = useState("add");
  const [backdrop, setBackdrop] = useState(false);

  const [updater, setUpdater] = useState({
    loading: false,
    slug: "",
    type: "",
  }); // type: delete | update

  const articleData = {
    title: "عنوان مقاله",
    description:
      "این یک توضیح مختصر برای مقاله است. متن حداکثر 300 کاراکتر است.",
    coverImage: articlePic,
    finalDescription:
      "این یک متن کامل برای مقاله است. متنی بلندتر و جامع‌تر که تمام جزئیات و اطلاعات مورد نیاز را شامل می‌شود. شامل پاراگراف‌های متنوع و عکس‌های مرتبط است.",
    mtm: 1689691279, // Example timestamp (in milliseconds)
    category: {
      label: "دستگاه های بخور",
      value: 1,
    }, // Example category ID
    subCategorys: [
      {
        label: "بخور سرد",
        value: 138,
      },
      // {
      //     label: "بخور گرم",
      //     value: 139,
      // },
      ,
    ], // Example subcategory ID
  };
  // console.log({ controllerProduct });
  return (
    <ManagementContext.Provider
      value={{
        showModalArticle,
        setShowModalArticle,
        type,
        setType,
        selectedArticle,
        setSelectedArticle,
        updater,
        setUpdater,
        controllerProduct,
        setControllerProduct,
        backdrop,
        setBackdrop,
      }}
    >
      {children}

      {auth.userInfo.userType == "0" && (
        <>
          <AddEditArticleModal data={articleData} />

          <InsertProductModal
            controller={controllerProduct}
            setController={setControllerProduct}
          />
        </>
      )}
    </ManagementContext.Provider>
  );
};
